import { Fragment } from 'react';
import { animationVariants } from '../../../../utils/framerMotion.utils';
import { AnimatePresence, motion, LazyMotion, domAnimation, m } from 'framer-motion';

export const MotionComponent = ({ slideMode = 'fromRight', children, disabledMotion = false }) => {
	if (disabledMotion) {
		return <Fragment>{children}</Fragment>;
	}
	return (
		<LazyMotion features={domAnimation}>
			<m.div
				initial="open"
				animate="open"
				exit="closed"
				variants={animationVariants[slideMode]}
				transition={{ duration: 0.5, ease: 'easeInOut' }}>
				{children}
			</m.div>
		</LazyMotion>
	);
};

export const MotionActionComponent = ({ slideMode = 'fromRight', isOpen, children }) => {
	return (
		<AnimatePresence>
			{isOpen && (
				<motion.div
					initial="closed"
					animate="open"
					exit="closed"
					variants={animationVariants[slideMode]}
					transition={{ duration: 0.5, ease: 'easeInOut' }}
					onAnimationComplete={() => !isOpen}>
					{children}
				</motion.div>
			)}
		</AnimatePresence>
	);
};

export const DropdownMotionComponent = ({ controls, children }) => {
	return (
		<LazyMotion features={domAnimation}>
			<m.div
				initial="closed"
				animate={controls}
				exit="closed"
				variants={{
					open: { opacity: 1, height: 'auto' },
					closed: { opacity: 0, height: 0 }
				}}
				transition={{ duration: 0.3 }}
				style={{ overflow: 'hidden' }}>
				{children}
			</m.div>
		</LazyMotion>
	);
};
